import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from '../ui/LoadingSpinner';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { user, profile, loading } = useAuth();
  const location = useLocation();
  const [showSpinner, setShowSpinner] = useState(true);

  // Previne o "flash" de redirecionamento ou spinner infinito
  useEffect(() => {
    if (!loading) {
        setShowSpinner(false);
    }
  }, [loading]);

  if (loading || showSpinner) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-cream-300 flex-col gap-4">
        <LoadingSpinner size="lg" />
        <p className="text-dark-500 text-sm animate-pulse">Autenticando...</p>
      </div>
    );
  }

  // Se não tem usuário autenticado, manda pro login
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Se o usuário existe, mas o perfil ainda é null (erro de sync), mas loading é false:
  // Deixa passar para o DashboardManager lidar com a tela de "Erro de Sincronização"
  // OU se a rota exigir role específica, aí sim bloqueamos.
  
  if (allowedRoles.length > 0) {
      // Se exige role, precisamos do perfil. Se perfil é null, é um problema.
      if (!profile) {
          // Redireciona para o dashboard genérico onde o DashboardManager vai mostrar o erro e botão de reparo
          return <Navigate to="/dashboard" replace />;
      }
      
      if (!allowedRoles.includes(profile.role)) {
        return <Navigate to="/" replace />;
      }
  }

  return children;
};

export default ProtectedRoute;